import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const SelectRemitenteEmail = ({value,disabled,onChange,isClearable,errorText,valRequerido, ...props}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';

    const [selectedValue, setSelectedValue] = useState();
    const [options, setOptions] = useState([]);
    const [items, setItems] = useState([
        {
            value: 'support@nubicomv2.zohodesk.com',
            label: 'support@nubicomv2.zohodesk.com'
        },{
            value: 'no-reply@nubicom.com.ar',
            label: 'no-reply@nubicom.com.ar'
        },{
            value: 'facturas@nubicom.com.ar',
            label: 'facturas@nubicom.com.ar'
        },{
            value: 'helpdesk@nubicom.com.ar',
            label: 'helpdesk@nubicom.com.ar'
        },{
            value: 'soporte@nubicom.com.ar',
            label: 'soporte@nubicom.com.ar'
        },{
            value: 'soportesaltasegura@nubicom.com.ar',
            label: 'soportesaltasegura@nubicom.com.ar'
        },{
            value: 'facturas@nubicomv2.zohodesk.com.ar',
            label: 'facturas@nubicomv2.zohodesk.com.ar'
        }
    ]);

    const onSelectValue =
        useMemo(() =>
            (ev) => {
                if(ev){
                    ev.item = options.find(it=>it.value === ev.value);
                    onChange(ev);
                } else {
                    onChange(null);
                }
            }
        , [])

    useEffect(() => {
        const newOptions = items
            .map((item) => {
            return {
                value: item.value,
                label: item.label,
            };
        });
        setOptions(newOptions);
    }, [items]);

    useEffect(() => {
        if( options.length > 0 ){
            if (typeof value === 'string') {
                setSelectedValue( options.find((opt) => opt.value === value) );
            }
        }
    }, [options,value])

    useEffect(() => {
        if(valRequerido){
            setItems([
                {
                    value: 'Activo',
                    label: 'Requerido'
                },{
                    value: 'Inactivo',
                    label: 'No Requerido'
                }
            ])
        }
    }, [valRequerido])
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff') 
                : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff') 
                : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#fff',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (styles) => ({
            ...styles,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (styles) => ({
            ...styles,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
    }), [isDarkMode])
    return (
        <Select
            {...props}
            className='react-select-container'
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder='Seleccione...'
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
        />
    );
};

SelectRemitenteEmail.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectRemitenteEmail;